import { useCallback, useEffect } from 'react';
import shallow from 'zustand/shallow';
import { subscriptionApi } from '@api';
import useHouseList from '../useHouseList';
import { IPackageSubscription } from '@root/types/package';
import { useSubscriptionsState } from '@root/state';

const useSubscriptionListAction = () => {
  const { currentHouseId: homeId } = useHouseList();
  const { setLoading, setList } = useSubscriptionsState(
    (state) => ({
      setLoading: state.setLoading,
      setList: state.setList,
    }),
    shallow,
  );
  const getSubscriptionList = useCallback(() => {
    if (!homeId) {
      return;
    }

    setLoading(0);

    subscriptionApi
      .getSubscriptionList({ homeId })
      .then((data: any) => {
        setList(data?.list || [], homeId);
        setLoading(1);
      })
      .catch(() => {
        setLoading(2);
      });
  }, [homeId, setList, setLoading]);

  return getSubscriptionList;
};

const useSubscriptionList = (): {
  list: IPackageSubscription[];
  loading: number;
} => {
  const { currentHouseId: homeId } = useHouseList();
  const { loading, list, stateHomeId, updateTime } = useSubscriptionsState(
    (state) => ({
      loading: state.loading,
      list: state.list,
      stateHomeId: state.houseId,
      updateTime: state.updateTime,
    }),
    shallow,
  );

  const getSubscriptionList = useSubscriptionListAction();

  useEffect(() => {
    if (
      stateHomeId !== homeId ||
      new Date().getTime() - updateTime > 30 * 1000
    ) {
      getSubscriptionList();
    }
  }, [getSubscriptionList, homeId, stateHomeId, updateTime]);

  return {
    list,
    loading: stateHomeId && stateHomeId === homeId ? 1 : loading,
  };
};

export { useSubscriptionListAction };

export default useSubscriptionList;
